// frontend/src/services/settings.service.ts
//
// Settings işlemleri doğrudan Supabase client'ı ile yapılır:
// - Profil güncelleme: RLS "kullanıcı kendi profilini güncelleyebilir" izni veriyor
// - Şifre değiştirme: Supabase Auth'un kendi updateUser API'si
// Backend'e gitmesi gereken bir AI çağrısı veya atomik işlem olmadığı için
// ayrı bir backend route'u gerekmiyor.

import { supabase } from '../lib/supabaseClient';
import { NotificationPreferences } from '../types/auth.types';
import { ProfileUpdateInput } from '../types/settings.types';

export const settingsService = {
  async updateProfile(userId: string, input: ProfileUpdateInput) {
    const { error } = await supabase
      .from('profiles')
      .update({
        full_name: input.full_name,
        age: input.age,
        school_name: input.school_name,
        interests: input.interests,
      })
      .eq('id', userId);

    if (error) throw error;
  },

  async updateNotificationPreferences(userId: string, prefs: NotificationPreferences) {
    const { error } = await supabase
      .from('profiles')
      .update({ notification_preferences: prefs })
      .eq('id', userId);

    if (error) throw error;
  },

  async updateAvatarStyle(userId: string, avatarStyle: string) {
    const { error } = await supabase.from('profiles').update({ avatar_style: avatarStyle }).eq('id', userId);
    if (error) throw error;
  },

  async changePassword(newPassword: string) {
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) throw error;
  },
};
